// Caminho relativo: src/environments/environment.hom.ts
import { Environment, EnvironmentName } from './environment.model';
 
export const environment: Environment = {
  name: EnvironmentName.production,
  production: true,
  authApi: 'https://api.hmg.suporteonfarm.com.br',
  api: 'https://api.hmg.suporteonfarm.com.br',
  offlineStore: {
    userProfile: true,
    farms: true,
    reasonList: true,
    productList: false,
    questions: false,
    sections: false,
    compatibility: false,
    problems: false,
    serviceOrders: false, 
    checklists: false,
    visitDiaries: false,
    managementPlans: false 
  }
};
